import { render, staticRenderFns } from "./CompensationYear.vue?vue&type=template&id=52dc3806"
import script from "./CompensationYear.vue?vue&type=script&lang=js"
export * from "./CompensationYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports